import Axios from "axios";
import Apis from "../../config/Apis";
import { hideLoading, showAlert, showLoading } from "../Actions/GeneralActions";
import { headers, platform } from "../../utills";
import {
  getTemplates,
  getMyTemplates,
  getGuestGroup,
  deleteGuestGroup,
  getGuestList,
  getMenu,
  getSeating,
  getAttendee,
  getAttendeeDetails,
  setRSVP,
  getPending,
} from "../Actions/EventPlanningActions";
import { getEventDetail } from "../Actions/EventAction";
import { EventMiddleware } from "./EventMiddleware";

export const EventPlanningMiddleware = {
  getTemplates: () => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.generalTemplates,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(getTemplates(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getTemplates",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  getMyTemplates: () => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(Apis.templates, await headers.config());
          if (data?.status == 200) {
            dispatch(hideLoading());
            resolve(true);
            dispatch(getMyTemplates(data?.data?.data));
          }
        } catch (error) {
          dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: "getMyTemplates",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  createTemplate: ({ name, image }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("name", name);
          formData.append("image", image);
          const data = await Axios.post(
            Apis.createTemplate,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getMyTemplates(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "createTemplate",
                message: data?.data?.message,
                type: "Success",
                status: data.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createTemplate",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  deleteTemplate: ({ id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("id", id);
          const data = await Axios.post(
            Apis.deleteTemplate,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getMyTemplates(data?.data?.data));
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "deleteTemplate",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  // DownloadAttachment: ({ file }) => {
  //     if (platform.OS == 'ios') {
  //         Linking.openURL(file?.attachment)
  //         return async dispatch => {
  //             console.log("Linking openURl IOS")
  //         };
  //     } else {
  //         let extension = file?.attachment.split('.')
  //         let title = file?.title + '.' + extension[extension.length - 1]
  //         let dirs = RNFetchBlob.fs.dirs
  //         return async dispatch => {
  //             dispatch(showLoading());
  //             let header = await headers.config()
  //             await RNFetchBlob
  //                 .config({
  //                     timeout: 60 * 60,
  //                     fileCache: true,
  //                     path: dirs.DownloadDir + '/' + file,
  //                     addAndroidDownloads: {
  //                         useDownloadManager: true,
  //                         notification: true,
  //                         // mime: 'application/pdf',
  //                         title: title,
  //                         path: platform.OS == 'ios' ? dirs.DocumentDir + '/' + title : dirs.DownloadDir + '/' + title,
  //                     },
  //                 })
  //                 .fetch("GET", file.attachment,
  //                     header.headers
  //                 )
  //                 .then((res) => {
  //                     dispatch(hideLoading())
  //                 }).catch((err) => {
  //                     dispatch(hideLoading())
  //                     console.warn(err);
  //                 })

  //         };
  //     }
  // },

  // Guest List & Guest Group

  guestGroups: ({ name, event_id }) => {
    return (dispatch) => {
      // dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          if (name) formData.append("name", name);
          formData.append("event_id", event_id);
          const data = await Axios.post(
            Apis.GuestGroup,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            // dispatch(hideLoading());
            dispatch(getGuestGroup(data?.data?.data));
            resolve(true);
          }
        } catch (error) {
          // dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: "getGuestGroup",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  createGuestGroup: ({ name, event_id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("name", name);
          formData.append("event_id", event_id);
          const data = await Axios.post(
            Apis.createGuestGroup,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(hideLoading());
            dispatch(getGuestGroup(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "createGuestGroup",
                message: data?.data?.message,
                type: "Success",
                status: data.status,
              })
            );
          }
        } catch (error) {
          dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: "createGuestGroup",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  deleteGuestGroup: ({ group_id, index }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("id", group_id);
          const data = await Axios.post(
            Apis.deleteGuestGroup,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(deleteGuestGroup(index));
            resolve(true);
            dispatch(
              showAlert({
                title: "deleteGuestGroup",
                message: data?.data?.message,
                type: "Success",
                status: data.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "deleteGuestGroup",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  createGuest: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("first_name", userdata?.first_name);
          formdata.append("last_name", userdata?.last_name);
          formdata.append("event_id", userdata?.event_id);
          formdata.append("email", userdata?.email);
          const data = await Axios.post(
            Apis.createEventGuest,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getGuestList(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "createGuest",
                message: data?.data?.message,
                type: "Success",
                status: data.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createGuest",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getGuests: ({ id, name, status }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          // dispatch(showLoading());
          let formData = new FormData();
          formData.append("event_id", id);

          if (name) formData.append("name", name);
          if (status) formData.append("status", status);

          // if (group) formData.append("group", group);

          const data = await Axios.post(
            Apis.eventGuests,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getGuestList(data?.data?.data));
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getGuests",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          // dispatch(hideLoading());
        }
      });
    };
  },

  deleteEventGuests: ({ id, event_id }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          // dispatch(showLoading());
          let formData = new FormData();
          formData.append("event_id", event_id);
          formData.append("user_id", id);

          // if (group) formData.append("group", group);

          const data = await Axios.post(
            Apis.removeEventGuest,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getGuestList(data?.data?.data));
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getGuests",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          // dispatch(hideLoading());
        }
      });
    };
  },

  updateGuest: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", userdata?.event_id);
          if (userdata?.guest_group_id)
            formdata.append("guest_group_id", userdata?.guest_group_id);
          if (userdata?.relation_id)
            formdata.append("relation_id", userdata?.relation_id);
          formdata.append("user_id", userdata?.user_id);
          const data = await Axios.post(
            Apis.updateEventGuest,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getGuestList(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "updateGuest",
                message: data?.data?.message,
                type: "Success",
                status: data.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "updateGuest",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  // Event Menu

  eventMenus: ({ id }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", id);
          const data = await Axios.post(
            Apis.eventMenus,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getMenu(data?.data?.data));
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "eventMenus",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  createEventMenu: ({ id, name, des }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", id);
          formData.append("name", name);
          formData.append("description", des);
          const data = await Axios.post(
            Apis.createEventMenu,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(hideLoading());
            dispatch(getMenu(data?.data?.data));
            resolve(true);
          }
        } catch (error) {
          dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: "createEventMenu",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  // Event Venue

  createEventVenue: ({ id, name, image }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formData = new FormData();
          formData.append("event_id", id);
          formData.append("image", image);
          const data = await Axios.post(
            Apis.createEventVenue,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getEventDetail(data?.data?.data));
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createEventVenue",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  // Event Table & Seating

  eventTables: ({ id, name }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          if (name) formData.append("name", name);

          formData.append("event_id", id);
          const data = await Axios.post(
            Apis.eventTables,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getSeating(data?.data?.data));
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "eventTables",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  createEventTable: ({ event_id, guest_group_id, name, type, seats }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", event_id);
          // formData.append("guest_group_id", guest_group_id);
          formData.append("name", name);
          // formData.append("type", type);
          formData.append("seats", seats);
          const data = await Axios.post(
            Apis.createEventTable,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getSeating(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "createEventTable",
                message: data?.data.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error?.response?.data?.message);
          dispatch(
            showAlert({
              title: "createEventTable",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  eventAttendees: ({ id, status, name }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          if (status) formData.append("status", status);
          if (name) formData.append("name", name);
          formData.append("event_id", id);
          const data = await Axios.post(
            Apis.eventAttendees,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getAttendee(data?.data?.data));
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "eventAttendees",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  eventPendingGuest: ({ id, status, name }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          if (status) formData.append("status", status);
          if (name) formData.append("name", name);
          formData.append("event_id", id);
          const data = await Axios.post(
            Apis.eventAttendees,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getPending(data?.data?.data));
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "eventAttendees",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  assignTable: ({ seats, event_id, attendeeDetails, table }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("table_id", table.id);
          formData.append("seats", seats);
          formData.append("event_id", event_id);
          formData.append("user_id", attendeeDetails?.id);
          const data = await Axios.post(
            Apis.assignTable,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(
              getAttendeeDetails({
                ...attendeeDetails,
                table_name: table.val,
                table_id: table.id,
              })
            );
            resolve(true);
            dispatch(
              showAlert({
                title: "eventAttendees",
                message: data?.data?.message,
                type: "success",
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "eventAttendees",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  eventAttendeeDetail: ({ event_id, user_id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", event_id);
          formData.append("user_id", user_id);
          const data = await Axios.post(
            Apis.eventAttendeeDetail,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getAttendeeDetails(data?.data?.data));
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "eventAttendeeDetail",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  updateAttendee: (attendee) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("id", attendee?.id);
          if (attendee?.meal_id) formData.append("meal_id", attendee?.meal_id);
          formData.append("name", attendee.name);
          const data = await Axios.post(
            Apis.updateAttendeesAndMeal,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getAttendeeDetails(data?.data?.data));
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "eventAttendeeDetail",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  generateGuestPdf: (event_id) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", event_id);
          const data = await Axios.post(
            Apis.downloadGuestPdf,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            let file = {
              attachment: data?.data?.data?.url,
            };
            // dispatch(EventPlanningMiddleware.DownloadAttachment({ file }));
            dispatch(
              showAlert({
                title: "generatePdf",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
            resolve(file);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "generatePdf",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  removeGuest: ({ event_id, user_id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", event_id);
          formData.append("user_id", user_id);
          const data = await Axios.post(
            Apis.removeEventGuest,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(EventMiddleware.getEventDetails({ id: event_id }));
            dispatch(getSeating(data?.data?.data));
            resolve(data?.data?.data);
            dispatch(
              showAlert({
                title: "removeGuest",
                message: data?.data.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error?.response?.data?.message);
          dispatch(
            showAlert({
              title: "removeGuest",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  // RSVP

  getRsvp: (event_id) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", event_id);
          const data = await Axios.post(
            Apis.rsvp,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(setRSVP(data?.data?.data));
            resolve(data?.data?.success);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createRsvp",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  sendRsvp: ({ event_id, users }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", event_id);

          if (users?.length > 0) {
            for (const [index, item] of users?.entries()) {
              formData.append(`userIds[${index}]`, item.id);
            }
          }
          const data = await Axios.post(
            Apis.sendRsvp,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "createRsvp",
                message: data?.data?.message,
                type: "success",
                status: data?.status,
              })
            );
            // dispatch(setRSVP(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createRsvp",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  createRsvp: (RSVP) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          console.log(RSVP);
          let formData = new FormData();
          // formData.append("address", RSVP?.address?.address);
          // formData.append("lat", RSVP?.address?.lat);
          // formData.append("lng", RSVP?.address?.lng);

          // formData.append("story", RSVP?.story);
          formData.append("event_id", RSVP?.event_id);

          formData.append("invite_type", RSVP?.invite_type);
          if (RSVP?.invite_type == "card") {
            formData.append("card_id", RSVP?.card_id);
          } else {
            formData.append("message", RSVP?.message);
            formData.append("tagline", RSVP?.tagline);
          }

          if (RSVP?.mealsArr?.length > 0) {
            for (const [index, item] of RSVP.mealsArr.entries()) {
              if (item.id) {
                formData.append(`meals[${index}][id]`, item.id);
              }
              formData.append(`meals[${index}][name]`, item.name);
              formData.append(`meals[${index}][description]`, item.description);
            }
          }
          if (RSVP?.tidbitsArr?.length > 0) {
            for (const [index, item] of RSVP.tidbitsArr.entries()) {
              if (item.id) {
                formData.append(`tidbits[${index}][id]`, item.id);
              }
              formData.append(`tidbits[${index}][question]`, item.question);
            }
          }
          // if (RSVP?.family?.length > 0) {
          //   for (const [index, item] of RSVP.family.entries()) {
          //     formData.append(`families[${index}][name]`, item.name);
          //     formData.append(`families[${index}][category]`, item.category);
          //     formData.append(`families[${index}][image]`, item.image);
          //   }
          // }
          // if (RSVP?.schedules?.length > 0) {
          //   for (const [index, item] of RSVP.schedules.entries()) {
          //     formData.append(`schedules[${index}][title]`, item.title);
          //     formData.append(
          //       `schedules[${index}][description]`,
          //       item.description
          //     );
          //   }
          // }
          // if (RSVP?.tidbits?.length > 0) {
          //   for (const [index, item] of RSVP.tidbits.entries()) {
          //     formData.append(`tidbits[${index}][type]`, item.answerType);
          //     formData.append(`tidbits[${index}][question]`, item.question);
          //     if (item?.answerType != "Description") {
          //       for (const [ind, option] of item?.options.entries()) {
          //         formData.append(
          //           `tidbits[${index}][options][${ind}][name]`,
          //           option.option
          //         );
          //         formData.append(
          //           `tidbits[${index}][options][${ind}][is_selected]`,
          //           option.selected
          //         );
          //       }
          //     }
          //   }
          // }
          const data = await Axios.post(
            Apis.updateRsvp,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(setRSVP(data?.data?.data));
            dispatch(
              showAlert({
                title: "createRsvp",
                message: data?.data?.message,
                type: "success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createRsvp",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
};
